import { NgModule } from '@angular/core';
import { NewsLetterComponent } from '../components/news-letter/news-letter.component';
import { FormModule } from 'src/core/modules/form.Module';
import { CustomValidatorsModule } from 'src/core/modules/custom-validators-module';
import { NewslettersService } from '../services/news-letter.service';




@NgModule({
  declarations: [
    NewsLetterComponent
  ],
  imports: [
    FormModule,
    CustomValidatorsModule,
  ],
  exports:[
    NewsLetterComponent,
    CustomValidatorsModule,
    FormModule
  ],
  providers: [
NewslettersService
  ]
})
export class NewsLetterModule { }
